/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */


import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import * as models from '../model/models';
import { Requester } from '../requester';
import { PagedArray } from '../paged-array';

/* tslint:disable:no-unused-variable member-ordering */


@Injectable()
export class NavItemsApi {
    constructor(
        protected requester: Requester
    ) {
    }

    /**
     * Set the list of navigation items
     * @param body 
     */
    public setNavItems(body?: models.ApiPutContentNavigation, __unused?: any): Observable<models.ApiNavigationItems> {
        const path = '/content/navigation';

        let queryParameters : Record<string,string> = {};
        let headers : Record<string,string> = {}; 

        let requestMethodStr = 'RequestMethod.Put'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;

        return this.requester
            .request<models.ApiNavigationItems>(
                requestMethodStr, 
                requestPath, 
                queryParameters,
                headers,
                body,
            );
    }

    /**
     * Get the list of navigation items
     */
    public getNavItems(__unused?: any): Observable<models.ApiNavigationItems> {
        const path = '/content/navigation';

        let queryParameters : Record<string,string> = {};
        let headers : Record<string,string> = {}; 

        let requestMethodStr = 'RequestMethod.Get'.replace(/RequestMethod\./, '').toUpperCase();
        let requestPath = path;

        return this.requester
            .request<models.ApiNavigationItems>(
                requestMethodStr, 
                requestPath, 
                queryParameters,
                headers,
            );
    }

}
